module.exports = __webpack_public_path__ + "a54934b47b0203d026a08e51faf3a77d.jpg";